import React from "react";
import HubSpotCompanyModalPicker from "components/Picker/HubSpotCompanyPicker/HubSpotCompanyModalPicker";
import GenericHubSpotPanel from "HubSpot/GenericHubSpotPanel";
import HubSpotLifecycleTag from "./HubSpotLifecycleTag";
import { YesNoText } from "components/ValidatedFields/YesNoRadioGroup";
import { CompanyFormState } from "shared/utils/fieldsHelper/companyFields";

interface Props {
  companyFormState: CompanyFormState;
}

export const HubSpotCompanyPanel = (props: Props) => {
  return <GenericHubSpotPanel
    initialHubSpotId={props.companyFormState.hubSpotCompanyId}
    urlToHubSpotEntity={(id) => `https://app.hubspot.com/contacts/5257648/record/0-2/${id}/`}
    title="HubSpot"
    apiKey="hubspot-company-section"
    collapsible={{
      start: "open",
      uniqueRowId: "hubspot-company-section",
      persist: true,
    }}

    fetch={window.CoreApi.HubSpot.GetCompany}
    link={{
      type: "autolink",
      link: id => window.CoreApi.Company.SetHubSpotCompanyId({ companyId: props.companyFormState.companyId, hubSpotCompanyId: id }),
      unlink: () => window.CoreApi.Company.SetHubSpotCompanyId({ companyId: props.companyFormState.companyId, hubSpotCompanyId: null }),
    }}
    create={{
      api: () => window.CoreApi.HubSpot.CreateCompany({ systemOneCompanyId: props.companyFormState.companyId }),
      createButtonLabel: "Create"
    }}
    renderPicker={onLink =>
      <HubSpotCompanyModalPicker
        canCreateNew={false}
        nonInPageEditing={{
          onChange: v => onLink(v.id),
          value: null,
          required: false,
          validatorKey: "hubSpotCompany",
        }}
      />
    }
    dataFields={hsCompany => [
      {
        key: "hubSpotName",
        label: "Name",
        render: () => <div>{hsCompany.name}</div>,
      }, {
        key: "hubSpotAddress",
        label: "Address",
        render: () => <div>{[hsCompany.city, hsCompany.countryName].filter(Boolean).join(", ")}</div>,
      }, {
        key: "hubspotLifecycleStage",
        label: "Lifecycle Stage",
        render: () => <HubSpotLifecycleTag hsCompany={hsCompany} />,
      }, {
        key: "hubspotExCustomer",
        label: "Ex-customer",
        render: () => <YesNoText value={hsCompany.exCustomer} />,
      }
    ]}
  />
}

export default HubSpotCompanyPanel;